<script setup lang="ts">
/**
 * UI-kit component
 * Category: Wrappers
 * Name: WrapperGeneralInfo
 */

defineOptions({
  name: 'WrapperGeneralInfo',
})
</script>

<template>
  <div class="wrapper-general-info">
    <div class="wrapper-general-info__main">
      <div
        v-if="$slots.info"
        class="wrapper-general-info__info"
      >
        <slot name="info" />
      </div>
      <div class="wrapper-general-info__separator" />
      <div
        v-if="$slots.additional"
        class="wrapper-general-info__additional"
      >
        <slot name="additional" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped src="../styles/_wrapper-general-info.scss" />
